import {Check} from 'lucide-react'
import {cn} from 'utils/cn'
import Sharpet from './Sharpet'
import {AVAILABLE_SPECIES, SHARPET_SPECIES} from './manifest'

/**
 * A grid of every species a member can pick, each drawn in its idle pose.
 * A radio group underneath, so arrow keys move between pets. `current`
 * marks the species the pet already is (when changing), which cannot be
 * picked again.
 */
const SharpetSpeciesPicker = ({value, onChange, current, className}) => (
  <div
    role="radiogroup"
    aria-label="Pick a Sharpet"
    className={cn('grid grid-cols-4 gap-1.5', className)}
  >
    {AVAILABLE_SPECIES.map((species) => {
      const {label} = SHARPET_SPECIES[species]
      const selected = species === value
      const isCurrent = species === current
      return (
        <label
          key={species}
          className={cn(
            'relative flex cursor-pointer flex-col items-center rounded-xl border px-1 pb-1.5 pt-1 text-center transition-colors',
            'has-[:focus-visible]:ring-2 has-[:focus-visible]:ring-sharpenn-coral/40',
            selected
              ? 'border-sharpenn-coral bg-sharpenn-coral/5'
              : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50',
            isCurrent && 'cursor-default opacity-60 hover:bg-transparent'
          )}
        >
          <input
            type="radio"
            name="sharpet-species"
            value={species}
            checked={selected}
            disabled={isCurrent}
            onChange={() => onChange(species)}
            className="sr-only"
          />
          {selected && (
            <Check
              aria-hidden="true"
              className="absolute right-1 top-1 h-3.5 w-3.5 text-sharpenn-coral"
            />
          )}
          <Sharpet species={species} size={52} animated={false} />
          <span className="text-[11px] font-medium leading-tight text-gray-700">
            {label}
          </span>
          {isCurrent && (
            <span className="text-[10px] leading-tight text-gray-500">Now</span>
          )}
        </label>
      )
    })}
  </div>
)

export default SharpetSpeciesPicker
